import React from 'react';
import { AccentCard } from '@netexknowledge/smart-components';

const DiscussionCardPlaceholder = () => (
  <AccentCard accentColor="#ddd" className="discussion-card">
    <div className="discussion-type-row">
      <span className="animated-background" style={{ width: '120px', height: '11px' }} />
    </div>
    <div className="top-row">
      <span>
        <div
          className="teacher-name animated-background"
          style={{ width: '30%', height: '15px', marginBottom: '25px' }}
        />
      </span>
    </div>
    <div className="discussion-info">
      <span className="discussion-title animated-background" style={{ width: '40%', height: '20px' }} />
      <span
        className="discussion-description animated-background"
        style={{ width: '95%', height: '10px', marginBottom: '15px' }}
      />
      <span
        className="discussion-description animated-background"
        style={{ width: '95%', height: '10px', marginBottom: '15px' }}
      />
      <span
        className="discussion-description animated-background"
        style={{ width: '70%', height: '10px', marginBottom: '15px' }}
      />
    </div>
    <div className="discussion-metadata-row">
      <div className="animated-background" style={{ width: '25%', height: '15px' }} />
      <div className="animated-background" style={{ width: '50%', height: '10px' }} />
      <div className="animated-background" style={{ width: '10%', height: '15px' }} />
    </div>
  </AccentCard>
);

export default DiscussionCardPlaceholder;
